import Title from '../../@iosper/components/Page/Title';
import { AmbulatorioMain } from '../pages';

export const Ambulatorio = () => {
  return (
    <>
      <Title autoFocus={false}>Prestaciones Ambulatorias</Title>
      <AmbulatorioMain />
    </>
  );
};
